export default __webpack_public_path__ + "static/media/title-icon.2f1480b4.svg";